import React from "react";
import { Redirect } from "react-router-dom";
import { canAccessDashboard, getRole, hasMinRole, ROLES } from "../utils/roles";
import { appPath, getRememberedAppSlug } from "../utils/appSlug";

const ProtectedRoute = ({ loginStatus, minRole, exactRole, allowedRoles, children }) => {
  if (!loginStatus?.sub) {
    const slug = loginStatus?.application_slug || getRememberedAppSlug();
    return <Redirect to={slug ? appPath(slug, "login") : "/login"} />;
  }

  const role = getRole(loginStatus);

  if (!canAccessDashboard(loginStatus)) {
    const slug = loginStatus.application_slug;
    return <Redirect to={slug ? `/${slug}` : "/"} />;
  }

  if (role === ROLES.SUPERADMIN) {
    return children;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Redirect to="/dashboard" />;
  }

  if (exactRole && role !== exactRole) {
    return <Redirect to="/dashboard" />;
  }

  if (minRole && !hasMinRole(loginStatus, minRole)) {
    return <Redirect to="/dashboard" />;
  }

  return children;
};

export default ProtectedRoute;
